module.exports = __webpack_public_path__ + "img/list3.787f3e80.jpg";